import {useApolloQuery} from '@packages/apollo-hooks'
import gql from 'graphql-tag'
import cloneDeep from 'lodash/cloneDeep'

export default function useSetOutOfStock({product: productParam, websiteId, storeId, deliverAt}) {
  const product = cloneDeep(productParam) ?? {}
  const modifierOptionsIds = []

  for (const modifiers of product.modifiers || []) {
    for (const option of modifiers.options || []) {
      modifierOptionsIds.push(option._id)
    }
  }

  const {outOfStockProducts, outOfStockModifierOptions} = useApolloQuery({
    query: gql`
      query getProductDetailsOutOfStock(
        $websiteId: ID
        $productsIds: [ID]
        $storeId: ID
        $deliverAt: Date
        $modifierOptionsIds: [ID]
      ) {
        outOfStockProducts: outOfStockProductsInList(
          websiteId: $websiteId
          productsIds: $productsIds
          storeId: $storeId
          deliverAt: $deliverAt
        )
        outOfStockModifierOptions: outOfStockModifierOptionsInList(
          websiteId: $websiteId
          modifierOptionsIds: $modifierOptionsIds
          storeId: $storeId
          deliverAt: $deliverAt
        )
      }
    `,
    variables: {
      productsIds: [product?._id],
      modifierOptionsIds,
      websiteId,
      storeId,
      deliverAt
    },
    partial: true,
    omit: !product || modifierOptionsIds.length === 0 || !storeId
  })

  if (!outOfStockProducts || !outOfStockModifierOptions)
    return {outOfStockModifierOptions: [], isOutOfStock: null}
  return {outOfStockModifierOptions, isOutOfStock: !!outOfStockProducts.length}
}
